module.exports = __webpack_public_path__ + "img/web1.d5a43e26.png";